import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import {
  resetSnack,
  successSnack,
  errorSnack,
} from "../snackbar/snackbarSlice";
import { resetProduct } from "../products/productsSlice";

import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchAuthToken = createAsyncThunk(
  "auth/fetchAuthToken",
  async (creds, thunkAPI) => {
    try {
      const response = await axios.post(`${baseURL}/auth/token`, creds);
      const token = response.data.token;
      thunkAPI.dispatch(resetSnack());
      thunkAPI.dispatch(resetProduct());
      localStorage.setItem("coreToken", token);
      localStorage.setItem("coreUser", creds.username);
      return await response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message.includes("401")
          ? { message: "Invalid Username or Password" }
          : { message: error.message }
      );
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (args, thunkAPI) => {
    try {
      //full options
      const response = await axios.get(
        `${baseURL}/v1/users/forgotpassword/${args.username}`
      ); //where you want to fetch data
      thunkAPI.dispatch(successSnack("Password Reset Email Sent"));

      return await response.json();
    } catch (error) {
      console.log('error', error.response);
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching users list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (args, thunkAPI) => {
    try {
      //full options
      // const config = {
      //   headers: { "X-Client-Host": args.host },
      // };
      const response = await axios.patch(
        `${baseURL}/v1/users/resetpassword`,
        args.credentials,
        // config
      ); //where you want to fetch data
      thunkAPI.dispatch(successSnack("Password Reset Successfully"));

      return await response.json();
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching users list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    signedIn: false,
    loading: "idle",
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAuthToken.pending, (state) => {
      state.signedIn = false;
      state.loading = "loading";
    });
    builder.addCase(fetchAuthToken.fulfilled, (state, { payload }) => {
      state.signedIn = true;
      state.loading = "loaded";
    });
    builder.addCase(fetchAuthToken.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.payload;
    });
  },
});

export const selectAuth = createSelector(
  (state) => ({
    auth: state.auth,
    signedIn: state.auth.signedIn,
    loading: state.auth.loading,
    error: state.auth.error,
  }),
  (state) => state
);
export default authSlice.reducer;
